import React from 'react';
import PrivateRoute from './PrivateRoute';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Composant de route protégée pour les administrateurs
 * Redirige vers la page de connexion si l'utilisateur n'est pas connecté
 * Redirige vers le tableau de bord si l'utilisateur n'est pas administrateur
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  return (
    <PrivateRoute requiredRole="admin">
      {children}
    </PrivateRoute>
  );
};

export default AdminRoute;
